import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Task from "./views/Task.vue";
import User from "./views/User.vue";
import Report from "./views/Report.vue";
import Register from "./views/Register.vue";
import Absent from "./views/Absent.vue";
import StaffList from "./views/StaffList";
import Leave from "./views/Leave.vue";
import AttendanceList from "./views/AttendanceList";
import {store} from "../store"

Vue.use(Router);

let router =  new Router({
  linkExactActiveClass: "active",
  routes: [
    
    {
      path: "/landing",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
   
      },meta: {
        requiresAuth: true
      }
    },
    {
      path: "/login",
      name: "login",
      components: {
      //  header: AppHeader,
        default: Login,
        footer: AppFooter
        
      }
    },
    {
      path: "/register",
      name: "register",
      components: {
      //  header: AppHeader,
        default: Register,
        footer: AppFooter
        
      }
    },
    {
      path: "/task",
      name: "task",
      components: {
        header: AppHeader,
        default: Task,
       
      },meta: {
        requiresAuth: true
      }
    },
    {
      path: "/user",
      name: "user",
      components: {
        header: AppHeader,
        default: User,
       
      },meta: {
        requiresAuth: true
      }
    },
    {
      path: "/report",
      name: "report",
      components: {
        header: AppHeader,
        default: Report,
      },meta: {
        requiresAuth: true
      }
    },
    {
      path: "/leave",
      name: "leave",
      components: {
        header: AppHeader,
        default: Leave,
      },meta: {
        requiresAuth: true
      }
    },
    {
      path: "/staff",
      name: "staffList",
      components: {
        header: AppHeader,
        default: StaffList,
      },meta: {
        requiresAuth: true
      }
    },
    {
      path: "/attendance-track",
      name: "AttendanceList",
      components: {
        header: AppHeader,
        default: AttendanceList,
      },meta: {
        requiresAuth: true
      }
    },
    {
      path: "/absent",
      name: "absent",
      components: {
        header: AppHeader,
        default: Absent,
      },meta: {
        requiresAuth: true
      }
    },
    { path: '*', redirect: '/report' }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {

  // console.log(JSON.parse(store.state.token))
 
  // if (store.state.token && new Date().getTime() > store.state.expiry) {
	
	// 	store.dispatch('logout')
	
  // }
  
  if(to.matched.some(record => record.meta.requiresAuth)) {
      if (!store.state.token) {
        store.dispatch('logout')
        return router.push({ name: 'login' });
      } else {
          
              next()
          
      }
    } else {
      next() 
    }
})

export default router
